import { render, staticRenderFns } from "./CrudDayOff.vue?vue&type=template&id=4635ab81&"
import script from "./CrudDayOff.vue?vue&type=script&lang=js&"
export * from "./CrudDayOff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports